import React from 'react'
import { convertMatchingRate } from '../../enums/MatchingRate'

interface MatchingRateBadgeProps {
  /** マッチング率（0-100） */
  matchingRate: number
  /** 自社かどうか。trueの場合は何も表示しない */
  isOwn: boolean
  /** 「マッチング率:」のラベルを表示するか（デフォルト: true） */
  showLabel?: boolean
  /** 追加のクラス名 */
  className?: string
}

/**
 * マッチング率を表示するバッジコンポーネント
 * 自社の場合は何も表示しない
 */
const MatchingRateBadge: React.FC<MatchingRateBadgeProps> = ({
  matchingRate,
  isOwn,
  showLabel = true,
  className = '',
}) => {
  return (
    <span
      className={`inline-block px-3 py-1 rounded-full bg-main-green text-main-white text-sm font-bold ${className}`}
    >
      {showLabel && 'マッチング率: '}
      {isOwn ? '-' : convertMatchingRate(matchingRate)}
    </span>
  )
}

export default MatchingRateBadge
